export type Block = { r: number; c: number; len: 2 | 3; dir: 'h' | 'v'; red?: true };
export type Level = { id: string; pack: string; n: number; blocks: Block[]; src?: { video: string; t: number; flags: string[] } };
export type LevelFile = { version: 1; levels: Level[] };
export const SIZE = 6;
export const EXIT_ROW = 2;

export function cellsOf(b: Block): [number, number][] {
  const out: [number, number][] = [];
  for (let i = 0; i < b.len; i++) out.push(b.dir === 'h' ? [b.r, b.c + i] : [b.r + i, b.c]);
  return out;
}

export function validateLevel(l: Level): string[] {
  const errs: string[] = [];
  const reds = l.blocks.filter((b) => b.red);
  if (reds.length !== 1) errs.push('red count');
  else if (reds[0]!.dir !== 'h' || reds[0]!.r !== EXIT_ROW) errs.push('red position');
  const seen = new Set<string>();
  l.blocks.forEach((b, i) => {
    if (b.len !== 2 && b.len !== 3) errs.push(`block[${i}] len`);
    for (const [r, c] of cellsOf(b)) {
      if (r < 0 || c < 0 || r >= SIZE || c >= SIZE) { errs.push(`block[${i}] out`); break; }
      const k = `${r},${c}`;
      if (seen.has(k)) errs.push(`overlap ${k}`);
      seen.add(k);
    }
  });
  return errs;
}
